<template>
  <div>
    <div>
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="共振趋势:">
            <el-select v-model="obj.trend" @change="handleSelectChange" style="width:110px">
              <el-option v-for="item in obj.trendList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="板块周期共振:">
            <el-select v-model="obj.interval_1" @change="handleSelectChange" style="width:110px">
              <el-option v-for="item in obj.interval_1_List" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合约周期共振:">
            <el-select v-model="obj.interval_2" @change="handleSelectChange2" style="width:110px">
              <el-option v-for="item in obj.interval_2_List" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <cpu />
              </el-icon>筛选
            </el-button>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" @click="handleRefresh">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
    </div>
    <!-- <el-tag type="warning" size="small" v-if="obj.date !== ''">数据截至到 {{ obj.date }}</el-tag> -->
    <el-tag type="warning" size="small">板块共振</el-tag>
    <div>
      <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) / 2 + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick" highlight-current-row ref="singleTableRef">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="130px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chg2Pct" align="right" width="100px" :sort-method="customPctSort" sortable />
        <el-table-column label="趋势开始日" prop="begin_date" width="120px" align="right" />
        <el-table-column label="统计截至日" prop="current_date" width="120px" align="right" />
        <el-table-column label="持续天数" prop="duration" width="120px" align="right" sortable />
        <el-table-column label="收阳天数" prop="up_count" width="120px" align="right" sortable />
        <el-table-column label="收阴天数" prop="down_count" width="120px" align="right" sortable />
        <el-table-column label="累计涨幅" prop="acc_chg_pct" width="120px" align="right" :sort-method="customPctSort2"
          sortable />
        <el-table-column label="累计趋势度" prop="acc_trend" width="120px" align="right" sortable />
      </el-table>
    </div>
    <div>
      <el-space wrap>
        <el-tag type="warning" size="small">合约共振</el-tag>
        <el-tag type="danger" size="small" v-if="obj.selectedBlock !== ''">{{ obj.selectedBlock }}</el-tag>
      </el-space>
    </div>
    <div>
      <el-table :data="obj.dataList_2" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) / 2 + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick2">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="130px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chg2Pct" align="right" width="100px" :sort-method="customPctSort" sortable />
        <el-table-column label="趋势开始日" prop="begin_date" width="120px" align="right" />
        <el-table-column label="统计截至日" prop="current_date" width="120px" align="right" />
        <el-table-column label="持续天数" prop="duration" width="120px" align="right" sortable />
        <el-table-column label="收阳天数" prop="up_count" width="120px" align="right" sortable />
        <el-table-column label="收阴天数" prop="down_count" width="120px" align="right" sortable />
        <el-table-column label="累计涨幅" prop="acc_chg_pct" width="120px" align="right" :sort-method="customPctSort2"
          sortable />
        <el-table-column label="累计趋势度" prop="acc_trend" width="120px" align="right" sortable />
      </el-table>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const singleTableRef = ref()
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      trendList: [
        {
          value: 'Long',
          label: '多头'
        },
        {
          value: 'Short',
          label: '空头'
        },
      ],
      trend: 'Long',
      interval_1_List: [
        {
          value: 'd',
          label: '日'
        },
        {
          value: 'w',
          label: '日周'
        },
        {
          value: 'm',
          label: '日周月'
        },
      ],
      interval_1: 'd',
      interval_2_List: [
        {
          value: 'd',
          label: '日'
        },
        {
          value: 'w',
          label: '日周'
        },
        {
          value: 'm',
          label: '日周月'
        },
      ],
      interval_2: 'd',
      dataList: [],
      dataList_2: [],
      date: '',
      selectedBlock: '',
      selectedBlockValue: '',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.resonanceData === '') {
        // 无缓存，从后台请求数据
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      formData.append("trend", obj.trend)
      formData.append("interval", obj.interval_1)
      formData.append("block", "all")
      http({
        url: `/resonance`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        processData(res.data.data)
        setStore()

        // 获取合约共振数据
        // if (obj.dataList.length > 0){
        //   // setCurrent(obj.dataList[0])
        //   obj.selectedBlock = obj.dataList[0].name
        //   obj.selectedBlockValue = obj.dataList[0].symbol
        //   requestData2(obj.dataList[0].symbol)
        // } else {
        //   obj.dataList_2 = []
        // }
      })
    }

    // const setCurrent = (row) => {
    //   singleTableRef.value.setCurrentRow(row)
    // }

    // 后台获取数据2
    const requestData2 = (symbol) => {
      let formData = new FormData()
      formData.append("trend", obj.trend)
      formData.append("interval", obj.interval_2)
      formData.append("block", symbol)
      http({
        url: `/resonance`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的合约')
        }
        processData2(res.data.data)
        setStore()
      })
    }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.forEach((item) => {
        // obj.date = item.date
        if (item.chg2Pct !== "-") {
          item.chg2Pct = parseFloat(item.chg2Pct * 100).toFixed(2) + '%'
          item.acc_chg_pct = parseFloat(item.acc_chg_pct * 100).toFixed(2) + '%'
          item.acc_trend = parseFloat(item.acc_trend).toFixed(2)
        }
        item.no = no
        no++
      })
      obj.dataList = data
    }

    // 处理数据2
    const processData2 = (data) => {
      let no = 1
      data.forEach((item) => {
        // obj.date = item.date
        if (item.chg2Pct !== "-") {
          item.chg2Pct = parseFloat(item.chg2Pct * 100).toFixed(2) + '%'
          item.acc_chg_pct = parseFloat(item.acc_chg_pct * 100).toFixed(2) + '%'
          item.acc_trend = parseFloat(item.acc_trend).toFixed(2)
        }
        item.no = no
        no++
      })
      obj.dataList_2 = data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'trend': obj.trend,
        'interval_1': obj.interval_1,
        'interval_2': obj.interval_2,
        'dataList': obj.dataList,
        'dataList_2': obj.dataList_2,
        'date': obj.date,
        'selectedBlock': obj.selectedBlock,
        'selectedBlockValue': obj.selectedBlockValue
      }
      store.commit('setResonanceData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.trend = store.state.resonanceData.trend
      obj.interval_1 = store.state.resonanceData.interval_1
      obj.interval_2 = store.state.resonanceData.interval_2
      obj.dataList = store.state.resonanceData.dataList
      obj.dataList_2 = store.state.resonanceData.dataList_2
      obj.selectedBlock = store.state.resonanceData.selectedBlock
      obj.selectedBlockValue = store.state.resonanceData.selectedBlockValue
    }

    // 重置画面
    const resetView = () => {
      obj.trend = 'Long'
      obj.interval_1 = 'd'
      obj.interval_2 = 'd'
      obj.dataList = []
      obj.dataList = ''
      obj.dataList_2 = []
      obj.dataList_2 = ''
      obj.selectedBlock = ''
      obj.selectedBlockValue = ''
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      obj.selectedBlock = ""
      obj.selectedBlockValue = ""
      obj.dataList_2 = []
      requestData()
    }

    // 下拉框选择事件2
    const handleSelectChange2 = (e) => {
      if (obj.selectedBlockValue != "") {
        requestData2(obj.selectedBlockValue)
      }
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      obj.selectedBlock = ""
      obj.selectedBlockValue = ""
      obj.dataList_2 = []
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      obj.selectedBlock = row.name
      obj.selectedBlockValue = row.symbol
      let symbol = row.symbol
      requestData2(symbol)
    }

    // 表格行点击事件2
    const handleRowClick2 = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 按钮提交事件
    const handleSubmit = () => {
      // if (!formCheck()) {
      //   return
      // }
      obj.selectedBlock = ""
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.indicators.trim() === '' && obj.patterns.trim() === '' &&
        (obj.customize.trim() === '' || obj.symbols.trim() === '')) {
        ElMessage.error('请选择或输入条件')
        return false
      }
      return true
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg2Pct.toString().replace('%', '') > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg2Pct.toString().replace('%', '') < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.acc_chg_pct.toString().replace('%', '') > 0 && row.columnIndex === 10) {
        return { color: 'red' }
      } else if (row.row.acc_chg_pct.toString().replace('%', '') < 0 && row.columnIndex === 10) {
        return { color: 'green' }
      }
      if (row.row.acc_trend > 0 && row.columnIndex === 11) {
        return { color: 'red' }
      } else if (row.row.acc_trend < 0 && row.columnIndex === 11) {
        return { color: 'green' }
      }
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chg2Pct.replace('%', '')) - parseFloat(b.chg2Pct.replace('%', ''))
    }

    // 表格排序2(带百分号的数字列)
    const customPctSort2 = (a, b) => {
      return parseFloat(a.acc_chg_pct.replace('%', '')) - parseFloat(b.acc_chg_pct.replace('%', ''))
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleSelectChange2,
      handleRefresh,
      handleRowClick,
      handleRowClick2,
      handleSubmit,
      cellStyle,
      customPctSort,
      customPctSort2
    }
  }
}
</script>
<style lang="scss" scoped></style>
